<script setup>
import { onMounted, reactive, ref } from 'vue'
import useCustomer from '../../../store/customer.store'
import { localeDatePicker } from '../../../utils'
import { useQuasar } from 'quasar'
import { callApi } from '../../../utils'
import apiAddress from '../../../api/address.api'
import { useUrlQuery } from '../../../utils/useUrlQuery'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

const $q = useQuasar()

const data = reactive({
  startTime: null,
  endTime: null,
  name: null,
  email: null,
  phone: null,
  addressId: null,
})

const addressOptions = ref([])
onMounted(async () => {
  try {
    const { data: list } = await apiAddress.getList({ 'page-size': 1000 })
    addressOptions.value = list.map(a => ({ label: a.name, value: a._id }))
  } catch (e) {
    console.error('Failed to load addresses', e)
  }
  filter()
})

const { getCustomerList, clearCustomerList, loading, pagination } = useCustomer()
const { pushToUrl, clearUrl } = useUrlQuery(data, filter)

function filter () {
  pushToUrl()
  callApi([getCustomerList], {
    'page-size': parseInt(pagination.value.rowsPerPage),
    'newer-than': data.startTime,
    'older-than': data.endTime,
    name: data.name,
    email: data.email,
    phone: data.phone,
    addressId: data.addressId || undefined,
  }, $q, loading, true)
}

function reset () {
  data.startTime = null
  data.endTime = null
  data.name = null
  data.email = null
  data.phone = null
  data.addressId = null
  clearUrl()
  clearCustomerList()
}
</script>

<template lang='pug'>
.customer-filter
  q-form(
    @submit='filter'
    @reset='reset'
    class="filter"
  )
    .column
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.startTime'
          :label='t("filter.time.start")'
          mask='####-##-## ##:##:##'
          hide-bottom-space
          hide-hint
        )
          template(v-slot:append)
            q-icon(name='schedule' class='cursor-pointer')
              q-popup-proxy
                div(style='border: 1px solid #ddd; border-radius: 10')
                  q-date(
                    v-model='data.startTime'
                    mask='YYYY-MM-DD HH:mm:ss'
                    minimal
                    :locale='localeDatePicker()'
                  )
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.endTime'
          :label='t("filter.time.end")'
          mask='####-##-## ##:##:##'
          hide-bottom-space
          hide-hint
        )
          template(v-slot:append)
            q-icon(name='schedule' class='cursor-pointer')
              q-popup-proxy
                div(style='border: 1px solid #ddd; border-radius: 10')
                  q-date(
                    v-model='data.endTime'
                    mask='YYYY-MM-DD HH:mm:ss'
                    minimal
                    :locale='localeDatePicker()'
                  )
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.name'
          :label='t("customer.name")'
          hide-hint
          hide-bottom-space
        )
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.email'
          :rules="[ (val, rules) => rules.email(val) || !val ]"
          :label='t("customer.email")'
          hide-hint
          hide-bottom-space
        )
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.phone'
          :label='t("customer.phone")'
          mask='###########'
          hide-hint
          hide-bottom-space
        )
      .col-auto.q-mb-md
        q-select(
          outlined
          v-model='data.addressId'
          :options='addressOptions'
          :label='t("customer.address")'
          emit-value
          map-options
          clearable
          hide-hint
          hide-bottom-space
        )
      .col-auto.q-mb-md
        q-btn(
          style='width: 100%; height: 46px'
          :label="t('actions.clear')"
          type="reset"
          :loading='loading'
          flat
        )
      .col-auto
        q-btn(
          style='width: 100%; height: 46px'
          :label="t('actions.search')"
          type="submit"
          :loading='loading'
          outline
          size='auto'
          color='primary'
        )        
</template>